export const TOGGLE_TIMER_FROZEN = "TOGGLE_TIMER_FROZEN"
export const TOGGLE_TIMER_RUNNING = "TOGGLE_TIMER_RUNNING"
export const START_TIMER = "START_TIMER"
export const STOP_TIMER = "STOP_TIMER"
export const SET_TIME = "SET_TIME"
export const CHANGE_TIMER_INPUT = "CHANGE_TIMER_INPUT"
